import { saveAs } from 'file-saver'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

//UI
import { Button } from '@chakra-ui/react'

//Hooks
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import useFile from '@/features/files/useFile'
import { useTranslation } from 'react-i18next'

const DownloadButton = ({ fileId, fileName }) => {
  const { useDownloadFile } = useFile()
  const { t } = useTranslation()
  const downloadFile = useDownloadFile()
  const dispatch = useDispatch()

  const handleDownloadFile = useCallback(async () => {
    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(fileId)
      const contentDisposition = response.headers['content-disposition']
      let fileName = 'e-approval-file'

      if (contentDisposition && contentDisposition.includes('filename=')) {
        fileName = contentDisposition.split('filename=')[1].replace(/"/g, '')
      }

      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      })
      saveAs(blob, fileName)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }, [dispatch, downloadFile, fileId, fileName])

  if (!fileId || !fileName || fileId === '' || fileName === '') {
    return <></>
  }
  return (
    <Button
      colorScheme="green"
      onClick={(e) => {
        e.stopPropagation()

        handleDownloadFile()
      }}
    >
      {t('BUTTON_DOWNLOAD')}
    </Button>
  )
}

export default DownloadButton
